import { Component } from '@angular/core'
import { YesNoDialogModel } from './dialog.model'
import { CaDialogComponent } from './ca-dialog.base'

@Component({
    selector: 'ca-yes-no-dialog',
    template: `
        <div class="curtain">
            <section class="component-modalDialog redesigned" id="test-yesNoDialog">
                <header>
                    {{title}}
                </header>
                <div class="contentContainer scrollable nativeScrollbar inside">
                    <div class="col-full no-height">
                        <p class="message" *ngFor="let paragraph of content">
                            {{paragraph}}
                        </p>
                    </div>
                </div>
                <footer>
                    <a class="button-primary" (click)="resolve(true)" id="dialog-yesno-button-primary">{{yesLabel}}</a>
                    <a class="button-secondary" (click)="resolve(false)" id="dialog-yesno-button-secondary">{{noLabel}}</a>
                </footer>
            </section>
        </div>`,
    standalone: false
})
export class YesNoDialogComponent extends CaDialogComponent<YesNoDialogModel, boolean> implements YesNoDialogModel {
    title: string
    content: string[]
    yesLabel: string
    noLabel: string

    resolve(resolution: boolean): void {
        this.result = resolution
        this.close()
    }

}